module.exports = __webpack_public_path__ + "static/media/sqm-logo.b12b1153.png";